<template>
  <div>
    <div class="Steps">
      <el-steps :active="currentIndex">
        <el-step v-for="(item, index) in nodeList" :key="index" :title="item.flowNodeName"
          :description="item.conditionExpr" @click.native="clickNodeDetail(index, item)"></el-step>
      </el-steps>
      <div class="stepRight">
        <div v-if="nodeDetail && nodeDetail.flowNodeId" class="step_type">
          <span style="margin-right: 20px"> 审批人 </span>
        </div>
        <div class="rightConent">
          <div v-for="(res, index) in nodeDetail.assigneeList" :key="index">
            <div class="rightConentTop">
              <div>
                <userItem :user="res" :can-delete="false" />
                <template v-if="res.result">
                  <flowNodeStatus style="margin-right: 10px" :status="res.result" />
                </template>
                <el-button v-if="
                  nodeDetail.allowAddApproverDynamic === 1 &&
                    nodeDetail.nodeStatus === '2' &&
                    routerParams.viewParam == 'approve'
                " size="mini" type="danger" round @click="deteleApproveUser">
                  删除
                </el-button>
              </div>
              <div v-if="res.approvalTime">
                <span>审批时间： {{ res.approvalTime }}</span>
              </div>
            </div>
            <div class="rightConentBottom">
              <div v-if="res.comment">
                <span style="white-space:pre-wrap ">
                  审批意见:
                  <span>{{ res.comment }}</span></span>
              </div>
              <div v-if="res.flowNodeFileVos.length !== 0">
                <span v-for="(data, fileIndex) in res.flowNodeFileVos" :key="fileIndex">
                  <span style="color:#00b632;cursor: pointer;" @click="preview(data)">{{ data.fileName }}</span>
                  <span style="color:#f37c26;cursor: pointer;" @click="uploadRowType(data)">下载</span>
                </span>
              </div>
            </div>
          </div>
          <addBtn v-if="allowChangeAssigneeList(nodeDetail)" @click="addApproveUser(nodeDetail)" />
        </div>
        <div v-if="ccList && ccList.length" class="step_type">
          <span style="margin-right: 20px"> 抄送人 </span>
        </div>
        <div v-if="ccList && ccList.length" class="rightConent">
          <template v-if="ccList.length === 1">
            <userItem :user="ccList[0]" :can-delete="false" />
          </template>
          <template v-if="ccList.length === 2">
            <userItem :user="ccList[0]" :can-delete="false" />
            <userItem :user="ccList[1]" :can-delete="false" />
          </template>
          <template v-if="ccList.length >= 3">
            <userItem :user="ccList[0]" :can-delete="false" />
            <userItem :user="ccList[1]" :can-delete="false" />
            <userItem :user="ccList[2]" :can-delete="false" />
            <span v-if="ccList.length > 3" style="color: var(--theme-color); cursor: pointer;"
              @click="showCCList(nodeDetail.flowNodeId)">更多</span>
          </template>
        </div>
      </div>
      <div class="header">
        流程完成后抄送人
      </div>
      <div>
        <div v-if="!ccUserList || !ccUserList.length" class="userList">
          无抄送人
        </div>
        <userList :users="ccUserList" />
      </div>
    </div>
    <el-dialog v-loading="loading" v-dialogDrag title="抄送人详情" :visible.sync="dialogVisible" width="30%"
      :before-close="close" element-loading-text="数据加载中" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div>
        <el-table :data="ccList" highlight-current-row border>
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column label="抄送人" prop="userName" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">
          取 消
        </el-button>
      </div>
    </el-dialog>
    <personChoose ref="personChoose" :select-list="nodeDetail.assigneeList || []" @personChoose="handleUserSelected">
    </personChoose>
  </div>
</template>
<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import personChoose from "./personChoose.vue";
import xtDesign from "@/CommonDP/service/integratedModel-service";
import { noLabelFilePreview, is3DModel, is2DModel } from "@/CommonDP/utils/docPublic";
import { downloadUrltoken } from "@/CommonDP/utils";
import flowNodeStatus from "@/CommonDP/components/flowComponents/flowNodeStatus";
import { gettouxAvatar } from "@/CommonDP/utils";
import userItem from "@/CommonDP/pages/components/launchFlow/components/userItem";
import addBtn from "@/CommonDP/pages/components/launchFlow/components/addBtn";
import userList from "@/CommonDP/pages/components/launchFlow/components/userList";

export default {
  components: { personChoose, flowNodeStatus, userItem, addBtn, userList },
  props: {
    setFlowInstanceNodeId: {
      required: true,
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      nodeList: [],
      dialogVisible: false,
      currentNode: null,
      loading: false,
      currentIndex: 0,
      nodeDetail: {},
      loadingcc: false,
      status: null,
      flowNodeName: "",
      ccUserList: [],
      ccUserIdList: []
    };
  },

  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      routerParams: (state) => state.projectMg.routerParams,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // cad跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    // rvt跳转样式
    isRVT() {
      if (window.location.href.indexOf("jsName=BimExRVT") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    ccList() {
      return this.nodeDetail?.ccList || [];
    }
  },
  methods: {
    async queryCCUserIdList() {
      const res = await flowService.queryCCUserIdList(this.routerParams.flowInstanceId);
      this.ccUserIdList = res.data.map((item) => item.userName).join(", ");
      this.ccUserList = res.data || [];
    },
    allowChangeAssigneeList(nodeDetail) {
      return nodeDetail.allowAddApproverDynamic;
    },

    clickNodeDetail(index, node) {
      this.currentIndex = index;
      this.nodeDetail = node;
    },
    setNodeList(nodeList) {
      nodeList.forEach((node, index) => {
        node.addedApproveUserList = [];
        node.addedCCUserList = [];
        node.assigneeList.forEach((user) => {
          user.img = gettouxAvatar(user.userId);
        });
        node.ccList.forEach((user) => {
          user.img = gettouxAvatar(user.userId);
        });
        this.loadingcc = true;
        try {
          this.setNodeConditionExpr(node, index);
        } finally {
          this.loadingcc = false;
        }
      });
      this.nodeList = nodeList;
      if (this.status !== 2) {
        this.setCurrentIndex();
      }
    },
    setNodeConditionExpr(node, index) {
      if (node.nodeStatus === "1") {
        node.conditionExpr = "  (已同意)";
      } else if (node.nodeStatus === "2") {
        this.currentIndex = index;
        this.nodeDetail = node;
        // 获取节点名称
        this.setFlowNodeName(node);

        // 获取flowInstanceNodeId
        this.setFlowInstanceNodeId(node.flowNodeId);

        // 判断是否为cad打开的
        // 判断是否为revit打开的
        if (!this.showBar || !this.isRVT) {
          node.assigneeList.forEach((ele) => {
            if (ele.userId === this.routerParams.userId) {
              // cad端审批人跟登录人一至
              this.$emit("setFlowApproveUser", true);
            }
          });
        }
        node.conditionExpr = "  (审批中)";
      } else if (node.nodeStatus === "3") {
        node.conditionExpr = "  (发起)";
      } else if (node.nodeStatus === "4") {
        node.conditionExpr = "  (再发起)";
      } else if (node.nodeStatus === "5") {
        node.conditionExpr = "  (已撤回)";
      } else if (node.nodeStatus === "0") {
        node.conditionExpr = "  (已驳回)";
      }
    },
    setCurrentIndex() {
      this.currentIndex = this.nodeList.length - 1;
      this.nodeDetail = this.nodeList[this.nodeList.length - 1];
    },
    setFlowStatus(status) {
      this.status = status;
    },
    setFlowNodeName(node) {
      this.flowNodeName = node.flowNodeName;
    },
    getFlowNodeName() {
      return this.flowNodeName;
    },
    // 添加人员弹框
    addApproveUser(node) {
      this.currentNode = node;
      this.$nextTick(() => {
        this.$refs.personChoose.type = 0;
        this.$refs.personChoose.personChooseTitle = "审批人设置";
        this.$refs.personChoose.show();
      });
    },
    // 删除人员
    deteleApproveUser() {
      this.$confirm(`您确定要删除此审批人吗`, { type: "warning" }).then((res) => {
        if (res === "confirm") {
          // TODO 调接口并处理当前展示的审批人列表
        }
      });
    },
    handleUserSelected(list, type) {
      if (type == 0) {
        this.AddApproveUser(list);
      }
    },
    async AddApproveUser(userList) {
      let newUser = {};
      const newArr = [];
      const obj = {};
      for (let i = 0; i < userList.length; i++) {
        // 将arr[i].id作为对象属性进行判断
        if (!obj[userList[i].userId]) {
          newArr.push(userList[i]);
          obj[userList[i].userId] = true;
        }
      }
      newUser = {
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId,
        flowInstanceNodeId: this.currentNode.flowNodeId,
        userIds: newArr.map((item) => item.userId)
      };
      const assigneeList = this.currentNode.assigneeList || [];
      for (const item of newArr) {
        const canAddUser = this.canAddUser(item, assigneeList);
        if (canAddUser) {
          const newUser = {
            userId: item.userId,
            userName: item.name,
            flowNodeFileVos: [],
            approvalTime: "",
            img: gettouxAvatar(item.userId)
          };
          assigneeList.push(newUser);
        }
      }
      const res = await flowService.dynamicAddApprover(newUser);
      if (res.result === "0") {
        this.$success("审批人员添加成功");
      }
    },
    canAddUser(user, assigneeList) {
      const found = assigneeList.find((item) => item.userId === user.userId);
      if (found) {
        return false;
      }
      return true;
    },
    showCCList(flowNodeId) {
      this.dialogVisible = true;
      this.loading = true;
      const list = this.nodeList.find((item) => item.flowNodeId === flowNodeId);
      this.ccList = list.ccList;
      this.loading = false;
    },
    close() {
      this.dialogVisible = false;
    },
    async uploadRowType(row) {
      // 判断文件是否删除
      const fileId = row.fileId;
      await flowService.flowFileIsExit(fileId);
      const prjId = this.prjInfo.prjId;
      window.location = downloadUrltoken(prjId, fileId);
    },
    async getprjList() {
      const param = {
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    },
    // 文件预览打开,文件变色
    async preview(row) {
      this.onLineView(row);
    },
    async onLineView(row) {
      let prjId;
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.fileVersion,
        fileType: row.fileType,
        status: row.status
      };
      if (!this.showBar) prjId = this.prjInfo.prjId;
      else prjId = this.prjInfo.prjId;
      // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prjName = prjList.filter((item) => {
        if (item.prjId === prjId) return item.prjName;
      })[0].prjName;
      const obj = {
        fileId: row.fileId,
        fileNames: row.fileName,
        prjId,
        prjName,
        status: row.status,
        versionIds: row.fileVersion,
        fileType: row.fileType,
        source: "ct"
      };
      if (this.flowKey === "check") {
        // 判断是否为cad打开的
        if (!this.showBar) {
          obj.noNeedIssue = "";
          await this.isSuccess(obj);
        } else noLabelFilePreview(value, prjId, prjName, "ct", "");
      } else {
        if (!this.showBar) {
          obj.noNeedIssue = "yes";
          await this.isSuccess(obj);
        } else noLabelFilePreview(value, prjId, prjName, "ct", "yes");
      }
    },
    async isSuccess(obj) {
      const { status } = obj;
      if (is3DModel(obj) || is2DModel(obj)) {
        if (Number(status) === 2 || Number(status) === 6) {
          window.cefSharpBrower.openUrl(JSON.stringify(obj));
        } else {
          this.$message.warning("文件还未轻量化,不支持预览");
        }
      } else {
        window.cefSharpBrower.openUrl(JSON.stringify(obj));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rightConent {
  width: 90%;
  margin-left: 1%;

  div {
    margin: 5px 0;
  }

  span {
    margin-right: 5px;
  }

  .rightConentTop {
    display: flex;
    justify-content: space-between;
  }
}

.Steps {
  padding: 20px 90px 20px 90px;
  width: 100%;
  box-sizing: border-box;

  /deep/ .el-steps {
    width: 100%;
  }

  /deep/ .el-step {
    &__title {
      font-size: 1em;
      line-height: 23px;
    }

    &__head.is-finish {
      color: #c0c4cc;
      border-color: #c0c4cc;
    }

    &__title.is-finish,
    &__description.is-finish {
      color: #c0c4cc;
      cursor: pointer;
    }

    &__head.is-process {
      color: #346ffa;
      border-color: #346ffa;
    }

    &__icon.is-text {
      cursor: pointer;
    }

    &__description.is-process,
    &__title.is-process {
      color: #000000;
      font-weight: normal;
    }
  }

  .stepRight {
    padding-top: 1px;
    width: 100%;

    .step_type {
      margin-top: 5px;
      padding: 1px 0;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      span {
        font-size: 16px;
        line-height: 23px;
        color: var(--theme-color);
      }
    }
  }
}

.header {
  font-size: 16px;
  line-height: 30px;
  color: var(--theme-color);
}
.hand {
  cursor: pointer;
}

.avatortox {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #4777e7;
  background: #4777e7;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}

.stepBottom {
  .step_type {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    span {
      font-size: 16px;
      line-height: 23px;
      color: var(--theme-color);
    }
  }
  padding: 0px 90px 20px 0px;
  width: 100%;
  // padding-top: 10px;
}

.userAvator {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 0 auto;
  margin-right: 2px;
  display: inline-block;
  vertical-align: middle;
}

.footer {
  display: flex;
  align-items: center;
  // margin-left: 5px;
  margin-bottom: 30px;
  margin-top: 30px;
  font-size: 16px;
  color: var(--theme-color);
  .footer_addbtn {
    margin-left: 15px;
  }
}
.el-icon-error {
  position: absolute;
  top: -12px;
  left: 20px;
  color: red;
  font-size: 18px;
  font-weight: 800;
  cursor: pointer;
}

.userAvator {
  border-radius: 50%;
  display: inline-block;
  vertical-align: top;
}

.table_class {
  font-size: 14px;
  border-radius: 15px;
  margin: 0 5px;
  text-align: center;
  color: var(--theme-color);
}

.approval_class {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}

.adopt_class {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
}

.reject_class {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}

.cancel_class {
  background: #d4d9ec;
  color: #fff;
}
</style>
